import React, { useMemo, useReducer } from "react";

import { MatchContext } from "../../../context";
import { initialMatchState, matchReducer } from "../../../reduce";

const StoreProvider = ({ children, initialState = initialMatchState }) => {
  const [state, dispatch] = useReducer(matchReducer, initialState);
  useMemo(() => [state, dispatch], [state]);
  return (
    <MatchContext.Provider value={{ state, dispatch }}>
      {children}
    </MatchContext.Provider>
  );
};

export default StoreProvider;
